import React from 'react';
import './HealthTwoFooter.scss';
import { FaInstagram, FaTwitter, FaFacebookF } from 'react-icons/fa';

const HealthTwoFooter = () => {
  return (
    <div className="health-two-footer-wrapper">
      <div className="footer-container">
        <div className="footer-links">
          <div className="footer-column">
            <h4>APP STORE</h4>
            <ul>
              <li>Digitech Solutions,Simplified</li>
              <li>Envisage & Innovate the most</li>
              <li>Curated Solutions for our</li>
              <li>valuable Customers</li>
              
            </ul>
          </div>
          <div className="footer-column">
            <h4>QUICK LINKS</h4>
            <ul>
              <li>Home</li>
              <li>FAQ</li>
              <li>Dashboard</li>
              <li>Notifications</li>
              <li>Product & Services</li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>CONTACTS</h4>
            <ul>
              <li>Gorakhpur,Uttar Pradesh</li>
              <li>hypercloud@gmail.com</li>
              <li>Linktree Pro</li>
              {/*  */}
            </ul>
          </div>
          <div className="footer-column">
            <h4>Trust & Legal</h4>
            <ul>
              <li>Terms & Conditions</li>
              <li>Privacy Notice</li>
              <li>Cookie Notice</li>
              <li>Trust Center</li>
              <li>Cookie Preferences</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="store-badges">
            <img src="/assets/img/health/healthTwo/appstore.png" alt="App Store" />
            <img src="/assets/img/health/healthTwo/gp.png" alt="Play Store" />
          </div>
          <div className="social-icons">
            <FaInstagram />
            <FaTwitter />
            <FaFacebookF />
          </div>
        </div>
      </div>

      <div className="footer-brand">
        <div className="footer-brand-content">
         
          <h2>Medicare</h2>
        </div>
       
      </div>
    </div>
  );
};

export default HealthTwoFooter;
